import { css } from "@emotion/react"

// @ts-ignore
import BackgroundImage from "@cirrus/assets/img/background-new.svg"

export const defaultSkin = css({
  // Main container (page)
  ".sfl.sfl-skin-adjustment": {
    background: `url('${BackgroundImage}') no-repeat 50% 50%`,
    backgroundSize: "cover",
    color: "#1A1A1A",
    // backgroundColor: "#454361"
  },

  // Card header
  ".sfl-wrapper #sfl-container .panel-heading": {
    // background: "#464361",
  },

  // Card content body
  ".sfl-wrapper #sfl-body": {
    // background: "#FFFFFF",
  },
})

// Also customizable elements:
// Buttons
// #sfl-body #submitButton:enabled (~:hover, ~:focus) {},
// #sfl-body #helpButton (~:hover, ~:focus) {},

// Inputs
// #sfl-body .MuiInputBase-root (~:before, ~:after) {}

// Logo
// .sfl-skin-adjustment .logo-header-background {}
